(function () {
  var DELAY_MS = 600;

  function init() {
    var modal = document.getElementById('modal-glow-promo');
    if (!modal) return;

    var jfId = Number(modal.getAttribute('data-jf-variant'));
    var glowId = Number(modal.getAttribute('data-glow-variant'));
    if (!jfId || !glowId) return;

    bindClose(modal);
    bindOffers(modal, jfId, glowId);

    setTimeout(function () {
      show(modal);
    }, DELAY_MS);
  }

  function bindClose(modal) {
    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(modal);
      });
    });

    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-visible')) {
        close(modal);
        document.removeEventListener('keydown', onKey);
      }
    });
  }

  function bindOffers(modal, jfId, glowId) {
    modal.querySelectorAll('[data-glow-offer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var offer = btn.getAttribute('data-glow-offer');
        var items =
          offer === 'a'
            ? [
                { id: jfId, quantity: 2 },
                { id: glowId, quantity: 1 }
              ]
            : [
                { id: jfId, quantity: 1 },
                { id: glowId, quantity: 1 }
              ];

        addBundle(modal, btn, items);
      });
    });
  }

  function show(modal) {
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close(modal) {
    modal.classList.add('is-hiding');
    setTimeout(function () {
      modal.classList.remove('is-visible', 'is-hiding');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }, 250);
  }

  function cartAddUrl() {
    var routes = (window.themeVariables && window.themeVariables.routes) || {};
    return (routes.cartAddUrl || (window.Shopify && Shopify.routes && Shopify.routes.root + 'cart/add') || '/cart/add') + '.js';
  }

  function cartUrl() {
    var routes = (window.themeVariables && window.themeVariables.routes) || {};
    return (routes.cartUrl || (window.Shopify && Shopify.routes && Shopify.routes.root + 'cart') || '/cart') + '.js';
  }

  async function addBundle(modal, btn, items) {
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('disabled', 'disabled');

    try {
      var response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items,
          sections: ['mini-cart']
        })
      });

      var json = await response.json();
      if (!response.ok) {
        throw new Error((json && json.description) || 'Could not add to cart');
      }

      var cartContent = await (await fetch(cartUrl(), { cache: 'reload' })).json();
      cartContent.sections = json.sections;

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: true
          }
        })
      );

      close(modal);
    } catch (err) {
      console.error('[glow-promo]', err);
      window.alert(err.message || 'Could not add to cart. Please try again.');
    } finally {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('disabled');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
